function normaliseCoordinate(value) {
    const coordinateString = String(value ?? '').trim();
    if (coordinateString === '')
        return null;

    const coordinate = Number(coordinateString);
    return Number.isFinite(coordinate) ? coordinate : null;
}

function hasUsableCoordinates(latitude, longitude) {
    const parsedLatitude  = normaliseCoordinate(latitude);
    const parsedLongitude = normaliseCoordinate(longitude);

    if (parsedLatitude === null || parsedLongitude === null)
        return false;

    if (parsedLatitude === 0 && parsedLongitude === 0)
        return false;

    return parsedLatitude >= -90
        && parsedLatitude <= 90
        && parsedLongitude >= -180
        && parsedLongitude <= 180;
}

export {
    hasUsableCoordinates
};
